import { DataGridProps, DataGrid as MuiDataGrid } from '@mui/x-data-grid';

const DataGrid = ({ rows, columns, ...rest }: DataGridProps) => {
  return (
    <MuiDataGrid
      rows={rows}
      columns={columns}
      autoHeight
      hideFooter
      initialState={{
        pagination: {
          paginationModel: {
            // pageSize: 10,
          },
        },
      }}
      disableRowSelectionOnClick
      {...rest}
    />
  );
};

export default DataGrid;
